import {
  TextField,
  Select,
  MenuItem,
  Button,
  Avatar,
} from "@mui/material";
import axios from "axios";
import Sidebar from "components/Sidebar/Sidebar";
import { Spinner } from "components/Spinner";
import { useLayout } from "context/layout/layout";
import { useStore } from "context/store/store";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import config from "services/config";
import { defaultMember } from "utils/state";
import { colors } from "utils/theme";

// Mónica Maldonado default
const DEFAULT_OWNER_ID = "68884ca95e090d505ad0afa6";

const Field = ({ label, children, half }) => (
  <div style={{ flex: half ? "0 0 calc(50% - 0.5rem)" : "0 0 100%", minWidth: 0 }}>
    <label
      style={{
        display: "block",
        fontSize: "0.8rem",
        fontWeight: 600,
        color: "#334155",
        marginBottom: "0.375rem",
      }}
    >
      {label}
    </label>
    {children}
  </div>
);

export const AddMember = () => {
  return (
    <>
      <Sidebar />
      <div style={{ marginLeft: 210, minHeight: "100vh", background: "#f8fafc" }}>
        <AddMemberForm />
      </div>
    </>
  );
};

function AddMemberForm() {
  const layout = useLayout();
  const store = useStore();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({ ...defaultMember, owner: DEFAULT_OWNER_ID });
  const [memberships, setMemberships] = useState([]);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    axios.get(`${config.url}/membership/list`).then(({ data }) => setMemberships(data)).catch(console.log);
    axios.get(`${config.url}/users/showall`).then(({ data }) => setUsers(data.filter((u) => u.gdriveFolderId))).catch(console.log);
  }, []);

  const selectedOwner = users.find((u) => u._id === user.owner);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!user.name || !user.email || !user.id_number) {
      layout.errorAlert({ message: "Nombre, email y RUT son obligatorios" });
      return;
    }

    if (!user.subscription?.type || !user.subscription?.startDate) {
      layout.errorAlert({ message: "Selecciona un plan y fecha de inscripción" });
      return;
    }

    setLoading(true);
    store
      .createMember(user)
      .then(() => {
        setLoading(false);
        layout.successAlert({ message: "Cliente creado exitosamente" });
        navigate("/admin/members");
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        layout.errorAlert({ message: err?.response?.data?.msg || "Error al crear el cliente" });
      });
  };

  const inputSx = {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      borderRadius: "0.5rem",
      backgroundColor: "#fff",
      fontSize: "0.9rem",
      "& fieldset": { borderColor: "#e2e8f0" },
      "&:hover fieldset": { borderColor: "#cbd5e1" },
      "&.Mui-focused fieldset": { borderColor: colors.sapphire },
    },
  };

  return (
    <>
      {loading && <Spinner />}

      {/* Header */}
      <div
        style={{
          padding: "1.75rem 2rem 1.5rem",
          borderBottom: "1px solid #e2e8f0",
          background: "#fff",
        }}
      >
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <p
            style={{
              fontSize: "0.75rem",
              fontWeight: 600,
              color: "#94a3b8",
              textTransform: "uppercase",
              letterSpacing: "0.05em",
              margin: 0,
              marginBottom: "0.25rem",
            }}
          >
            Nuevo registro
          </p>
          <h1 style={{ fontSize: "1.5rem", fontWeight: 700, color: "#0f172a", margin: 0 }}>
            Inscribir cliente
          </h1>
        </div>
      </div>

      <div style={{ maxWidth: 900, margin: "0 auto", padding: "1.5rem 2rem" }}>
        <form onSubmit={handleSubmit}>
          {/* Ejecutivo card */}
          <div
            style={{
              background: "#fff",
              borderRadius: "0.75rem",
              border: "1px solid #e2e8f0",
              padding: "1.25rem 1.5rem",
              marginBottom: "1rem",
            }}
          >
            <p
              style={{
                fontSize: "0.7rem",
                fontWeight: 600,
                color: "#94a3b8",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
                margin: 0,
                marginBottom: "0.75rem",
              }}
            >
              Ejecutivo asignado
            </p>
            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
              <div style={{ flex: 1 }}>
                <Select
                  fullWidth
                  value={user.owner || ""}
                  onChange={(e) => setUser({ ...user, owner: e.target.value || null })}
                  size="small"
                  displayEmpty
                  sx={{
                    borderRadius: "0.5rem",
                    backgroundColor: "#f8fafc",
                    "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e2e8f0" },
                    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#cbd5e1" },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: colors.sapphire },
                  }}
                >
                  <MenuItem value="">Sin asignar</MenuItem>
                  {users.map((u) => (
                    <MenuItem key={u._id} value={u._id}>
                      {u.name} ({u.email})
                    </MenuItem>
                  ))}
                </Select>
              </div>
              {selectedOwner && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    padding: "0.375rem 0.75rem",
                    borderRadius: "0.5rem",
                    backgroundColor: "#dcfce7",
                  }}
                >
                  <Avatar
                    sx={{
                      width: 24,
                      height: 24,
                      fontSize: "0.65rem",
                      fontWeight: 700,
                      backgroundColor: "#16a34a",
                      color: "#fff",
                    }}
                  >
                    {selectedOwner.name?.split(" ").map((n) => n[0]).join("").slice(0, 2)}
                  </Avatar>
                  <span style={{ fontSize: "0.8rem", fontWeight: 600, color: "#15803d" }}>
                    Se creará carpeta en Google Drive
                  </span>
                </div>
              )}
            </div>
          </div>

          {/* Main form card */}
          <div
            style={{
              background: "#fff",
              borderRadius: "0.75rem",
              border: "1px solid #e2e8f0",
              padding: "1.5rem",
              marginBottom: "1rem",
            }}
          >
            <p
              style={{
                fontSize: "0.7rem",
                fontWeight: 600,
                color: "#94a3b8",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
                margin: 0,
                marginBottom: "1rem",
              }}
            >
              Datos del cliente
            </p>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
              <Field label={<>Nombre <span style={{ fontSize: "0.65rem", backgroundColor: "#dbeafe", color: "#1e40af", padding: "1px 6px", borderRadius: 4, fontWeight: 600, marginLeft: 4 }}>icontador*</span></>} half>
                <TextField
                  fullWidth
                  size="small"
                  placeholder="Nombre y apellidos"
                  value={user.name}
                  onChange={(e) => setUser({ ...user, name: e.target.value })}
                  sx={inputSx}
                />
              </Field>
              <Field label="RUT" half>
                <TextField
                  fullWidth
                  size="small"
                  placeholder="12.345.678-9"
                  value={user.id_number}
                  onChange={(e) => setUser({ ...user, id_number: e.target.value })}
                  sx={inputSx}
                />
              </Field>
              <Field label="Correo electrónico" half>
                <TextField
                  fullWidth
                  size="small"
                  type="email"
                  placeholder="correo@empresa.cl"
                  value={user.email}
                  onChange={(e) => setUser({ ...user, email: e.target.value })}
                  sx={inputSx}
                />
              </Field>
              <Field label="Razón Social" half>
                <TextField
                  fullWidth
                  size="small"
                  placeholder="Razón social de la empresa"
                  value={user.company_information?.razon_social || ""}
                  onChange={(e) => setUser({ ...user, company_information: { ...user.company_information, razon_social: e.target.value } })}
                  sx={inputSx}
                />
              </Field>
              <Field label="Teléfono" half>
                <TextField
                  fullWidth
                  size="small"
                  placeholder="+56 9 1234 5678"
                  value={user.phone}
                  onChange={(e) => setUser({ ...user, phone: e.target.value })}
                  sx={inputSx}
                />
              </Field>
            </div>
          </div>

          {/* Subscription card */}
          <div
            style={{
              background: "#fff",
              borderRadius: "0.75rem",
              border: "1px solid #e2e8f0",
              padding: "1.5rem",
              marginBottom: "1.5rem",
            }}
          >
            <p
              style={{
                fontSize: "0.7rem",
                fontWeight: 600,
                color: "#94a3b8",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
                margin: 0,
                marginBottom: "1rem",
              }}
            >
              Plan y suscripción
            </p>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
              <Field label="Plan" half>
                <Select
                  fullWidth
                  value={user.subscription?.membership || ""}
                  onChange={(e) => {
                    const selected = memberships.find((m) => m._id === e.target.value);
                    if (selected) {
                      setUser({
                        ...user,
                        subscription: {
                          ...user.subscription,
                          type: selected.title,
                          membership: selected._id,
                        },
                      });
                    }
                  }}
                  size="small"
                  displayEmpty
                  sx={{
                    borderRadius: "0.5rem",
                    backgroundColor: "#fff",
                    "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e2e8f0" },
                    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#cbd5e1" },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: colors.sapphire },
                  }}
                >
                  <MenuItem value="">Seleccionar plan...</MenuItem>
                  {memberships.map((m) => (
                    <MenuItem key={m._id} value={m._id}>
                      {m.title}
                    </MenuItem>
                  ))}
                </Select>
              </Field>
              <Field label="Fecha de inscripción" half>
                <TextField
                  fullWidth
                  size="small"
                  type="date"
                  value={user.subscription?.startDate || ""}
                  onChange={(e) =>
                    setUser({
                      ...user,
                      subscription: {
                        ...user.subscription,
                        startDate: e.target.value,
                      },
                    })
                  }
                  sx={inputSx}
                />
              </Field>
            </div>
          </div>

          {/* Actions */}
          <div style={{ display: "flex", gap: "0.75rem" }}>
            <Button
              variant="outlined"
              onClick={() => navigate("/admin/members")}
              sx={{
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.85rem",
                borderRadius: "0.5rem",
                padding: "0.6rem 1.5rem",
                borderColor: "#e2e8f0",
                color: "#475569",
                "&:hover": { borderColor: "#cbd5e1", backgroundColor: "#f8fafc" },
              }}
            >
              Cancelar
            </Button>
            <Button
              type="submit"
              variant="contained"
              disabled={loading}
              sx={{
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.85rem",
                borderRadius: "0.5rem",
                padding: "0.6rem 2rem",
                backgroundColor: colors.sapphire,
                boxShadow: "0 2px 8px rgba(3,83,164,0.25)",
                "&:hover": { backgroundColor: colors.oxfordBlue },
                "&:disabled": { backgroundColor: "#94a3b8" },
              }}
            >
              {loading ? "Creando..." : "Crear cliente"}
            </Button>
          </div>
        </form>
      </div>
    </>
  );
}
